import './brokerConvenienceTestYellowDisclaimer.scss';
import React from 'react'
import PropTypes from 'prop-types';

const BrokerConvenienceTestYellowDisclaimer = ({children, className}) => {
    const componentClassName = `br-convenience-question-yellow-disclaimer__container ${className} `
    return (
        <div className={componentClassName}>
            {children}
        </div>
    )
}

BrokerConvenienceTestYellowDisclaimer.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
}

export default BrokerConvenienceTestYellowDisclaimer
